import React, { useState } from 'react'
import ModalRequest from '../../components/ModalRequest'
import { Grid, Switch } from '@mui/material'
import { useForm } from 'react-hook-form'
import { Input } from '../../components/StyleComponent'
import axiosInstance from '../../config/axiosConfig'
import { urlConfig } from '../../config/apiConfig'
export default function AddGetway({
    open,
    setOpen,
    handleAlert,
    keyName,
    req,
}) {
    const { handleSubmit, setValue } = useForm()
    const [status, setStatus] = useState(false)
    const [loading, setLoading] = useState(false)
    const onSubmit = async (data) => {
        const body = { ...data, enable: status, keyName: keyName }
        setLoading(true)
        try {
            await axiosInstance.post(urlConfig.gateway, body)
            handleAlert('gateway create successfully.', 'success')
            setOpen(false)
            req()
        } catch (err) {
            handleAlert(
                `${err.response.data.message || 'No Internet'}`,
                'error',
            )
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (name, value) => {
        setValue(name, value)
    }
    return (
        <ModalRequest
            disabled={loading}
            open={open}
            setOpen={setOpen}
            title={'Add New Gateway'}
            onSubmit={handleSubmit(onSubmit)}
        >
            <Grid item xs={12}>
                <Input
                    label='Gateway name'
                    name='name'
                    required
                    onChange={(e) => handleChange('name', e.target.value)}
                />
            </Grid>
            <Grid item xs={12}>
                <Input
                    label='Descriptions '
                    required
                    name='description'
                    onChange={(e) =>
                        handleChange('description', e.target.value)
                    }
                />
            </Grid>

            {/* <Grid item xs={12}>
                <Input
                    label='SN'
                    required
                    name='s_n'
                    onChange={(e) => handleChange('s_n', e.target.value)}
                />
            </Grid> */}
            <Grid item xs={12} align='right'>
                <span style={{ fontWeight: 'bold' }}>Enable</span>
                <Switch
                    color='success'
                    onChange={(_, v) => setStatus(v)}
                    checked={status}
                />
            </Grid>
        </ModalRequest>
    )
}
